import Select from 'react-select'
import styled from 'styled-components'

const StyledSelect = styled(Select)`
  width: 100%;

  .react-select {
    ${p => p.highlightSelected && `
      &__control:hover {
        .react-select__single-value,
        .react-select__placeholder,
        .react-select__dropdown-indicator {
          color: var(--color-text-primary, #fff);
        }
      }
    `}

    &__menu {
      position: absolute;
    }

    &__option {
      background-color: var(--color-bg-card, #2a2a2a);
      color: var(--color-text-primary);

      &:hover {
        background-color: var(--color-bg-sidebar, #3a3a3a);
      }

      &::after {
        content: '';
        width: 20px;
        height: 20px;
        clip-path: polygon(50% 50%, 0% 100%, 100% 100%);
        background-color: ${p =>
    p.selected === p.options?.[0]?.value ? 'var(--color-bg-sidebar, #3a3a3a)' : 'var(--color-bg-card, #2a2a2a)'};
        position: absolute;
        top: 0;
        right: 30px;
        transform: translateY(-95%);
        z-index: 1;
      }

      &:first-child {
        background-color: ${p =>
    p.selected === p.options?.[0]?.value && 'var(--color-bg-sidebar, #3a3a3a)'};
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }

      &:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
      }

      &:first-child:hover::after {
        background-color: var(--color-bg-sidebar, #3a3a3a);
        z-index: 2;
      }
    }
  }
`

const typographyStyles = {
  color: 'var(--color-text-secondary, #a5acc2)',
  fontSize: '14px',
  fontWeight: 'bold',
}

const Filter = ({
  handleFilter,
  selected,
  options,
  placeholder,
  defaultMenuIsOpen = false,
  highlightSelected = false,
  isMulti = false,
  ...rest
}) => {
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      ...typographyStyles,
      backgroundColor: state.isSelected ? 'var(--color-bg-sidebar, #3a3a3a)' : 'var(--color-bg-card, #2a2a2a)',
      padding: '12px',
      cursor: 'pointer',
    }),
    indicatorSeparator: (_provided, _) => ({ display: 'none' }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      marginTop: '2px',
      color: highlightSelected && (state.isFocused || state.selectProps.menuIsOpen) ? 'var(--color-text-primary, #fff)' : 'var(--color-text-secondary, #a5acc2)',
    }),
    singleValue: (provided, _state) => ({
      ...provided,
      ...typographyStyles,
      whiteSpace: 'nowrap',
      color: highlightSelected ? 'var(--color-text-primary, #fff)' : 'var(--color-text-secondary, #a5acc2)',
    }),
    placeholder: (provided, state) => ({
      ...provided,
      ...typographyStyles,
      whiteSpace: 'nowrap',
      color: highlightSelected && state.selectProps.menuIsOpen ? 'var(--color-text-primary, #fff)' : 'var(--color-text-secondary, #a5acc2)',
    }),
    menu: (provided, _) => ({
      ...provided,
      borderRadius: '4px',
      boxShadow: '0 2px 8px 0 rgba(0,0,0,0.2), 0 -2px 8px 0 rgba(0,0,0,0.2)',
      marginTop: '15px',
      backgroundColor: 'var(--color-bg-card, #2a2a2a)',
      border: '1px solid var(--color-border, rgba(255,255,255,0.1))',
    }),
    menuList: (provided, _) => ({
      ...provided,
      overflowY: 'visible',
      borderRadius: '4px',
      paddingTop: 0,
      paddingBottom: 0,
    }),
    control: (provided, state) => ({
      // none of react-select's styles are passed to <Control />
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0 8px',
      ...(isMulti ? { minHeight: '36px', flexWrap: 'wrap' } : { height: '36px' }),
      border: state.isFocused ? '2px solid var(--color-primary)' : '2px solid var(--color-text-secondary, #a5acc2)',
      borderRadius: '4px',
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      backgroundColor: 'var(--color-bg-card, #2a2a2a)',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(151, 202, 111, 0.2)' : 'none',
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: 'var(--color-bg-sidebar, #3a3a3a)',
      borderRadius: '3px',
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: 'var(--color-text-secondary, #a5acc2)',
      fontSize: '12px',
      fontWeight: 'bold',
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: 'var(--color-text-secondary, #a5acc2)',
      cursor: 'pointer',
      ':hover': {
        backgroundColor: 'var(--color-primary)',
        color: 'var(--color-bg-main, #101010)',
      },
    }),
  }

  return (
    <StyledSelect
      onChange={handleFilter}
      classNamePrefix='react-select'
      selected={selected}
      placeholder={placeholder}
      options={options}
      styles={customStyles}
      isSearchable={false}
      isMulti={isMulti}
      defaultMenuIsOpen={defaultMenuIsOpen}
      aria-label={placeholder || 'Select an option'}
      highlightSelected={highlightSelected}
      {...rest}
    />
  )
}

export default Filter
